import { SvgIcon, SvgIconProps, useTheme } from "@mui/material";

export const MenuBar = (props: SvgIconProps) => {
  const theme = useTheme();
  return (
    <SvgIcon width={props.width || 24} height={props.height || 24} viewBox="0 0 512 512" {...props}>
      <path d="" />
      <path fill={props.htmlColor || theme.palette.secondary[500]} d="M0 80c0-8.8 7.2-16 16-16l416 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L16 96C7.2 96 0 88.8 0 80zM64 240c0-8.8 7.2-16 16-16l416 0c8.8 0 16 7.2 16 16s-7.2 16-16 16L80 256c-8.8 0-16-7.2-16-16zM448 400c0 8.8-7.2 16-16 16L16 416c-8.8 0-16-7.2-16-16s7.2-16 16-16l416 0c8.8 0 16 7.2 16 16z" />
    </SvgIcon>
  );
};
